export const ARTICLE_PAGE = 'article' as const;
export const MEDIA_ARTICLE_PAGE = 'mediaArticle' as const;
export const MOST_READ_PAGE = 'mostRead' as const;
export const ERROR_PAGE = 'error' as const;
export const MEDIA_ASSET_PAGE = 'MAP' as const;
export const STORY_PAGE = 'STY' as const;
export const PHOTO_GALLERY_PAGE = 'PGL' as const;
export const CORRESPONDENT_STORY_PAGE = 'CSP' as const;
export const TOPIC_PAGE = 'topic' as const;
export const LIVE_PAGE = 'live' as const;
export const HOME_PAGE = 'home' as const;
export const CPS_ASSET = 'cpsAsset' as const;
export const STATIC_PAGE = 'static' as const;
export const UGC_PAGE = 'ugcForm' as const;
export const AV_EMBEDS = 'avEmbeds' as const;
export const DOWNLOADS_PAGE = 'downloads' as const;
export const LIVE_RADIO_PAGE = 'liveRadio' as const;
export const AUDIO_PAGE = 'audio' as const;
export const TV_PAGE = 'tv' as const;
